import { Box, Typography } from "@material-ui/core";
import "./data-exchange-content.component.scoped.scss";
import React, { useEffect, useState } from "react";
import FilesDropZone from "../../../../components/files-drop-zone/files-drop-zone.component";
import { fileTypes } from "../../../../statics/file-types";
import { icons } from "../../../../statics/icons";
import { useTranslation } from "react-i18next";
import DataExchangeAddCommentComponent from "./components/data-exchange-add-comment/data-exchange-add-comment.component";
import DataExchangeCommentComponent from "./components/data-exchange-comment/data-exchange-comment.component";
import { DataExchangeService } from "../../../../services/data-exchange.services";

const DataExchangeContentComponent = () => {
  const { t } = useTranslation();
  const dataExchangeService = new DataExchangeService();

  const [communications, setCommunications] = useState<any>([]);
  const [files, setFiles] = useState([]);

  const fetchData = async () => {
    const response = await dataExchangeService.list();
    setCommunications(response.data);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="global__box__content p-0 m-0 mb-5">
      <Box className="title">
        <Typography variant="subtitle2" style={{ fontWeight: 400 }}>
          {t("ACTIVITY_UPLOAD_AREA")}
        </Typography>
      </Box>

      <Box className="position-relative px-4">
        <FilesDropZone onDropFiles={setFiles} acceptTypes={fileTypes}>
          <Box className="text-center my-4">
            <Box className="drop-img">
              <img src={icons.DROP_FILE} alt="" />
            </Box>
            <Typography variant="h4">{t("DRAG_AND_DROP_FILE")}</Typography>
            <Typography variant="subtitle2">
              {t("RELEASE_THE_FILE_TO_UPLOAD")}
            </Typography>
          </Box>
          <Box className="form mb-4">
            <DataExchangeAddCommentComponent
              droppedFiles={files}
              onAddedComment={(comment: any) =>
                setCommunications((prev: any) => [comment, ...prev])
              }
            />
          </Box>
          <Box className="comments">
            {communications.map((comment: any, index: number) => {
              return (
                <React.Fragment key={index}>
                  <DataExchangeCommentComponent
                    comment={comment}
                    onDelete={(id: number) =>
                      setCommunications((prev: any) =>
                        prev.filter((comment: any) => comment.id !== id),
                      )
                    }
                  />
                </React.Fragment>
              );
            })}
          </Box>
        </FilesDropZone>
      </Box>
      <Box className="footer">
        <Typography
          variant="subtitle2"
          style={{
            textDecoration: "underline dashed",
            cursor: "pointer",
            fontWeight: 400,
            color: "var(--dark-primary)",
          }}
        >
          {t("VIEW_MORE")}
        </Typography>
      </Box>
    </Box>
  );
};

export default DataExchangeContentComponent;
